module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e132NaN"
    }
  }), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e823"
    }
  }, [_c('big', [_c('big', [_c('big', [_c('big', [_c('big', [_c('i', [_vm._v("I")])])], 1)], 1)], 1)], 1), _vm._v(" would not have spent $30,000 on college if I had known my greatest teacher would cost me $7.50. His name was Flopsy Parker. He taught me a lot of things, but his most valuable lesson was that sometimes the greatest gifts are the ones other people discard.")], 1), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1123"
    }
  }, [_vm._v("In life, people can choose their journeys. In my case, mine chose me. I walked into Guildford County shelter on a rainy Sunday afternoon with the intention of donating after seeing a newscast on rabbits that were abandoned after Easter. I left with a crazy-haired white rabbit that would lead me on the greatest journey of my life. I did not pick him that day. He picked me. ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e773"
    }
  }, [_c('b', [_vm._v("FOREWORD AND DEDICATION ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561281ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Park_9781937084721_epub_c3_r1.vue
// module id = 63
// module chunks = 0